import { connectWithStore } from '@common/connectWithStore';
import { defaultContractLength } from '@redux/ducks/global';
import { hideForm, toggleTerms, confirm, getState } from '@redux/ducks/account/pricingPlan/changePricingPlan';
import { ChangePricingPlanTerms } from './ChangePricingPlanTerms';

const mapStateToProps = state => {
  const { areTermsAccepted } = getState(state);

  return {
    defaultContractLength,
    areTermsAccepted,
  };
};

const mapDispatchToProps = {
  onCancel: hideForm,
  onConfirm: confirm,
  onToggleChange: toggleTerms,
};

export const ChangePricingPlanTermsContainer = connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePricingPlanTerms);
